import { Button, Typography, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { Box } from "@mui/system";
import React from "react";
import ColorHelper from "../../../Helpers/ColorHelper";
import FontHelper from "../../../Helpers/FontHelper";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { sponsorDiscount } from "../../../redux/shoppingActions";
import ClearIcon from '@mui/icons-material/Clear';
const SectionTitle3 = (props) => {
  const dispatch = useDispatch()
  const { title, sx, setOpenSponsorModal } = props;
  const location = useLocation()
  const findpath = location.pathname;
  const { appliedDiscount, discountedPhoto } = useSelector((state) => state.shop.sponsorDiscount)
  const cartPrice = useSelector((state) => state.shop.cartCheckout);
  const sponsorDetails = cartPrice?.getSponsorOffersDetails;
  const handleRemoveCoupon = () => {
    dispatch(sponsorDiscount({ apply: false, photoID: [] }))
  }
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginRight: "50px",
          pr: { xs: 0, md: 5, lg: 10 },
          my: 3,
          backgroundColor: ColorHelper.LightPurple,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontFamily: FontHelper.fBold,
              fontSize: "18px",
              padding: "8px ",
              color: ColorHelper.PrimaryColor,
              ...sx,
            }}
          >
            {title}
          </Typography>
          {title === "Digital Downloads" && props?.orderDetails?.bundle[0]?.id == "b_ultraprem" && (
            <Tooltip
              title="The photo and timed certificates are located in the 'certs' folder within the downloaded zip file."
              arrow
              placement="top"
              disableHoverListener={false}
              disableFocusListener={false}
              disableTouchListener={false}
              enterTouchDelay={0}
              leaveTouchDelay={3000}
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    maxWidth: '300px'
                  }
                }
              }}
            >
              <InfoIcon
                sx={{
                  color: ColorHelper.PrimaryColor,
                  fontSize: "18px",
                  cursor: "pointer"
                }}
              />
            </Tooltip>
          )}
        </Box>
        {title == "Digital Downloads" && findpath == "/cart" && appliedDiscount && <div style={{}}>
          <button onClick={handleRemoveCoupon} style={{
            border: "none",
            backgroundColor: "#9a1c27",
            color: "#fff",
            padding: "5px 10px",
            borderRadius: "5px",
            cursor: "pointer",
            float: "right"
          }}>
            {sponsorDetails.coupon_name} <span><ClearIcon style={{ verticalAlign: "middle", fontSize: "18px" }} /></span>
          </button>
        </div>}
      </Box>
    </Box>
  );
};

export default SectionTitle3;
